module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	var _ = {
		MARKREADDELAY: 1000,
		getMyNewMessage: function (params) {
			var now = new Date();

			var message = fox.merge({
				_ownerUser: {
					date: fox.utils.dateFormat('%B %e', now),
					datetime: fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', now),
					name: fox.site.member.getObjectValue('login'),
					time: fox.utils.dateFormat('%l:%M%P', now)
				},
				content: '',
				id: fox.uniqid(),
				my: 1,
				timestamp: fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', now),
				transferState: 1
			}, params);

			return message;
		},

		fillProcessingAttachments: function (messageId, uploadId) {
			if (messageId !== undefined && uploadId !== undefined) {
				if (!this.processingAttachments[messageId]) {
					this.processingAttachments[messageId] = [];
				}

				if (this.processingAttachments[messageId].indexOf(uploadId) === -1) {
					this.processingAttachments[messageId].push(uploadId);
				}
			}
		},

		prepareCollection: function (collection, fromModel, getFDay) {
			var
				day,
				_this = this.getClass() === 'ConversationViewer' ? this : this.getParent(),
				aa = _this.allAttachments,
				splitToken = _this.splitToken
			;

			if (getFDay === true) {
				day = fox.utils.dateFormat('%e', collection[0].timestamp);
			}

			if (fromModel === true) {
				fox.each(collection, function (v) {
					var
						dl = fox.createDl(),
						buff = [],
						obj
					;

					if (v.attachments !== undefined) {
						dl.setCollection(v.attachments.collection);
					}

					if (dl.getCount() > 0) {
						while ((obj = dl.iterateObject())) {
							var
								uploadId = obj.get('clientUploadUserAccessId.uploadId.id'),
								messageId = obj.get('messageId'),
								options
							;

							options = {
								messageId: messageId,
								contentId: uploadId,
								type: obj.get('clientUploadUserAccessId.uploadId.type'),
								price: obj.get('clientUploadUserAccessId.price'),
								paid: obj.get('clientUploadUserAccessId.paid'),
								attachTitle: obj.get('clientUploadUserAccessId.uploadId.title'),
								attachId: obj.get('id'),
								resId: obj.get('clientUploadUserAccessId.uploadId.resource.resourceId')
							};

							if (obj.get('clientUploadUserAccessId.uploadId.status') !== 3) {
								options.processing = true;

								_.fillProcessingAttachments.call(_this, messageId, uploadId);
							}

							aa.push(options);

							buff.push({id: uploadId, type: obj.get('clientUploadUserAccessId.uploadId.type')});
						}
					}

					if ((v.content && v.content.split(splitToken).length === 2) || v.type === 1) {
						v.hidden = 1;
					}

					if (dl.getCount() !== 0 && dl.getCount() !== buff.length) {
						v.hidden = 1;
					}
				}, this);
			}

			fox.each(collection, function (v, indx) {
				var curDay;
				var next = collection[indx + 1];

				if (v.serviceTypeAlias === 'gift') {
					var parts = v.content.split(':');

					v.gift = parts[0];
					v.price = parts[1];
				}

				if (v.timestamp === undefined) {
					v.timestamp = new Date().getTime();
				}

				curDay = fox.utils.dateFormat('%e', v.timestamp);

				if (day === undefined || day !== curDay) {
					v.diffDay = 1;
					day = curDay;
				}

				if (next !== undefined) {
					if (next.timestamp === undefined) {
						next.timestamp = new Date().getTime();
					}

					if (v.my === next.my &&
						fox.utils.dateFormat('%e', v.timestamp) === fox.utils.dateFormat('%e', next.timestamp)) {
						v.hideArrow = 1;
					}
				}
			});

			return collection;
		},

		attachProcessingSuccess: function (params, attach) {
			var indx;
			var showHidenMessage;

			function showHidenAttachments (messageId) {
				var
					list = this.rwom1('#list'),
					$attachmentsNode;

				$attachmentsNode = $(list.dom1(['#message-', messageId, ' .attachment-list'].join('')));

				if ($attachmentsNode.length) {
					this.scrollDown($attachmentsNode.parents('.message-row'), {});
				}
			}

			if (this.processingAttachments[attach.messageId]) {
				if ((indx = this.processingAttachments[attach.messageId].indexOf(attach.contentId)) !== -1) {
					this.processingAttachments[attach.messageId].splice(indx, 1);
				}

				if (this.processingAttachments[attach.messageId].length === 0) {
					this.processingAttachments[attach.messageId] = null;
					delete this.processingAttachments[attach.messageId];

					showHidenAttachments.call(this, attach.messageId);
				}
			}
		},

		cacheMessages: function () {
			var preloader = this.wom1('~.Preloader');

			if (preloader && preloader.skipDrawing !== false ) {
				preloader.skipDrawing = true;
			}

			this.waitEvent(this.dl, 'loaded', fox.bind(function (params, dl) {
				var c = dl.getCollection();

				if (c.length) {
					this.buffData.push(c);
				}
			}, this), {prefix: 'chachedData'});

			this.dl.setOffset(this.dl.getOffset() + this.dl.getLimit()).load();
		},

		resetScrollState: function () {
			var l = this.rwom1('#list');

			this.preventScrollDown = false;
			l.prevPrcV = 0;
			l.scrollTo = false;
		}
	};

	fox.registerWidget('ConversationViewer', {

		configure: function () {
			this.seenMessage = false;
			this.buffData = [];
			this.allAttachments = [];
			this.processingAttachments = {};
			this.splitToken = '%mediapaysuccess%';
			this._queue = [];

			this.registerOptions('', {
				autoRender: true,
				externalLoad: true,
				markAsReadOnAir: true,
				markAsReadOnWindowFocus: true,
				dontReuseSn: true,
				scrollbar:{
					theme: 'minimal-dark',
					position: 'outside'
				},
				'embed.container': '#messages-container',
				template: 'sitepage_conversation_messages_container',
				'widgets.dl': {
					widget: 'Datalayer',
					method: 'conversation.get',
					limit: 15,
					'metaFields.ownerUser': 1,
					'sorting.idSort': ['id', 'desc'],
					fields: ['_ownerUser.datetime', 'type'],
					'hooks.onPrepareResponse': this.onDlPrepareResponse
				},
				list: {
					widget: 'AdvancedList',
					notOverrideListBehavior: true,
					dontReuseSn: true,
					'tpl.row': 'sitepage_conversation_messages_row',
					'embed.container': '#messages-list',
					'hooks.onStartRendering': fox.bind(function () {
						if (this.seenMessage !== false) {
							var mes = this.rwom1('#list').filter('id', Number(this.seenMessage));

							if (mes.length) {
								mes[0].value.transferState = 2;

								this.seenMessage = false;
							}
						}
					}, this),
					'hooks.onStopRendering': fox.bind(function () {
						fox.each(this.allAttachments, this.embedAttachment, this);
					}, this),
					'hooks.onAddedToDom': function () {
						var parent = this.getParent();
						if (this.getParent().dontReloadAllList === true) {
							this.getParent().dontReloadAllList = false;

							return false;
						}

						if (this.getParent().getOption('markAsReadOnAir')) {
							this.getParent().delayedAsReadMarking(_.MARKREADDELAY);
						}

						var
							_this = this,
							$el = $(this.element[0]).parents('#messages-list-scroll-wrapper')
						;

						if (this.getParent().preventScrollDown !== true) {
							var scrollbarOptions = this.getParent().getOption('scrollbar');

							$el.mCustomScrollbar({
								theme: scrollbarOptions.theme,
								scrollbarPosition: scrollbarOptions.position,
								autoExpandScrollbar: true,
								callbacks: {
									onTotalScrollBack: function () {
										var
											drawCache,
											dl = _this.getParent().dl,
											bf = _this.getParent().buffData
										;

										drawCache = function () {
											var buffAmount = bf.length && bf[0].length;

											if (buffAmount) {
												var lastNode = document.getElementById('message-' + this.dataModel[0].value.id);

												$el.mCustomScrollbar('disable');

												this.scrollTo = function () {
													return lastNode ? lastNode.offsetTop + 100 : 300;
												};

												this.getParent().preventScrollDown = true;

												this.prependItem(bf.pop());

												if (buffAmount === dl._limit) {
													_.cacheMessages.call(this.getParent());
												}
											}
										};

										if (dl._loadStatus === 'loading') {
											_this.waitEvent(dl, 'loaded', fox.bind(function () {
												setTimeout(fox.bind(drawCache, this), 50);
											}, _this), {prefix: 'forDrawCache'});
										} else {
											drawCache.call(_this);
										}
									}
								}
							});

							this.getParent().scrollDown();
						}

						if (this.scrollTo) {
							this.getParent().scrollDown(this.scrollTo, {scrollInertia: 200});

							_.resetScrollState.call(this.getParent());
						}
					}
				},
				'widgets.sendMessageApi': {
					widget: 'Api',
					method: 'conversation.send',
					sendTimezone: true,
					httpMethod: 'post'
				},
				'widgets.previewContent': {
					widget: 'PreviewUploadedContent'
				},
				'widgets.attachUnlocker': {
					widget: 'Conversation_AttachUnlocker'
				},
				'widgets.tipme': {
					widget: 'Content_Tipme',
					embed: {
						container: '.tipme-container',
						widget: '@parent '
					}
				},
				handleWom: {
					messageInbox: {
						event: 'inboxSocketEventChat',
						widget: '@root #socket',
						callback: 'inboxSocketCallback',
						'params.alwaysActive': true
					},
					messageReadStatus: {
						event: 'inboxSocketEventMessageNotification',
						widget: '@root .Socket',
						'params.alwaysActive': true,
						callback: 'showMessageReadStatus'
					},
					showAttachment: {
						event: 'showAttachment',
						widget: '#list .Conversation_AttachItem',
						callback: function (p) {
							var
								pc = this.rwom1('#previewContent'),
								messageAttachments = this.rwom1('#list').getWidgetsByGroup(p.messageId),
								collection = [];

							if (fox.count(messageAttachments) > 1) {
								fox.each(messageAttachments, function (w) {
									var
										pd = w.getPublicData();

									if (!fox.isEmpty(pd)) {
										collection.push(pd);
									}
								});
							}

							pc.show({
								collection: collection,
								data: p
							});
						}
					},
					unlockAttachment: {
						event: 'unlockThisContent',
						widget: '#list .Conversation_AttachItem',
						callback: 'unlockAttachment'
					},
					attachProcessingSuccess: {
						event: 'attachProcessingSuccess',
						widget: '#list .Conversation_AttachItem',
						callback: fox.bind(_.attachProcessingSuccess, this)
					},
					globalUnlockEvent: {
						widget: '@root',
						event: 'unlockTransactionSuccessfully',
						callback: '_handleGlobalUnlockEvent',
						'params.alwaysActive': true
					}
				},
				handleDom: {
					openGiftPopup: {
						event: 'click',
						target: '#open-gift-popup',
						callback: function () {
							var popup = this.wom1('@root #conversationGiftsPopup');

							if (popup) {
								popup.show();
							}
						}
					},
					sendMessage: {
						event: 'click',
						target: '#send-message',
						callback: function () {
							this.sendMessageHandler();
						}.bind(this)
					},
					sendByEnter: {
						event: 'keydown',
						target: '#textarea',
						callback: function (el, alias, scope, e) {
							if (e.ctrlKey === true && e.keyCode === 13) {
								setTimeout(function () {
									this.sendMessageHandler();
								}.bind(this), 10);
							}

							if ([13, 46, 8].indexOf(e.keyCode) !== -1) {
								setTimeout(function () {
									el.style.height = [15 * el.value.split('\n').length, 'px'].join('');
								}, 10);
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			var pm = this.wom1('@root .PermissionManager');
			if ((pm && pm.hasAccess('guest')) || fox.site.member) {
				this.loadMessages();
			}

			if (this.getOption('markAsReadOnWindowFocus')) {
				this._addWindowFocusEvent();
			}
		
			this.callParent('running', arguments);
		},

		loadMessages: function () {
			this.waitEvent(this.dl, 'loaded', fox.bind(function (p, dl) {
				this.rwom1('#list').resetCollection(dl.getCollection());

				if (dl._collection.length === dl._limit) {
					setTimeout(fox.bind(_.cacheMessages, this), 10);
				}
			}, this));

			this.dl.load();

			return this;
		},

		activate: function () {
			this._addWindowFocusEvent();

			this.callParent('activate', arguments);
		},

		scrollDown: function (position, options) {
			var
				$listEl = $(this.rwom1('#list').element[0]).parents('#messages-list-scroll-wrapper');

			setTimeout(function () {
				try {
					$listEl.mCustomScrollbar('scrollTo', position || 'bottom', options || {
						scrollInertia: 0
					});
				} catch (e) {}

				if (position) {
					$listEl.mCustomScrollbar('update');

					return position;
				}
			}, 10);
		},

		sendMessageHandler: function (args) {
			var
				api = this.rwom1('#sendMessageApi'),
				$txtArea = $(this.dom1('#textarea')),
				list = this.rwom1('#list'),
				messageBody = $txtArea.val(),
				params = fox.merge({}, args || {}),
				lastId
			;

			function apiResponse (resp) {
				var _api = resp.performer;
				var res = resp.params;
				var lastMessageData = list.getDataById(lastId);

				lastId = null;

				if (res.answer.status === true && !fox.isEmpty(res.answer.response)) {
					lastMessageData.data.id = res.answer.response.messageId;
					lastMessageData.data.transferState = 0;

					this.dontReloadAllList = true;

					if (list.isEmbedded()) {
						list.updateItem(lastMessageData.data, lastMessageData.indx);
					} else {
						this.wait(list, 'addedToDom', {prefix: 'waitForChangeTransferState'}).then(function () {
							list.updateItem(lastMessageData.data, lastMessageData.indx);
						});
					}
				}

				_api.transferState = false;
			}

			if (messageBody.length || params.content) {
				if (!params.content) {
					params.content = this.changeInalidValue(messageBody);
				}

				if (!api.transferState) {
					lastId = this.addMessage(_.getMyNewMessage.call(this, params));
					params.content = this.window.encodeURIComponent(params.content);

					api.transferState = true;
					api.psend(params)
						.then(apiResponse.bind(this))
						.catch(apiResponse.bind(this));
					
					$txtArea.val('');
				}
			}
		},
		changeInalidValue: function (params) {
			var regExps = /<\s*[^>]*>/g;
			var entities = {'<': '', '>': ''};
			if(regExps.test(params)){
				params = params.replace(/[<>]/g, function (s) {return entities[s];});
			}
			return 	params;
		},
		_sendPaySuccessMessage: function (contentData) {
			//If ccbill postback recieved on oneclick transaction!;
			return false;
			//---------------------------------------------------
		},

		onDlPrepareResponse: function (response) {
			response.collection = _.prepareCollection.call(this, response.collection.reverse(), true);
			this._apiResponse = response;
		},

		getMessageById: function (id) {
			return this.dl._collection.filter(function (v) {
				return Number(v.id) === Number(id);
			}).pop();
		},

		embedAttachment: function (params) {
			var
				alias = [params.contentId, params.messageId].join('_'),
				l = this.rwom1('#list'),
				attach = l.getEmbeddedWidget(alias);

			if (!attach) {
				attach = l.embedWidget(alias, 'Conversation_AttachItem', {
					'embed.container': ['#at', alias].join('-'),
					price: params.price,
					type: params.type,
					contentId: params.contentId,
					messageId: params.messageId,
					group: params.messageId,
					paid: params.paid,
					attachTitle: params.attachTitle,
					attachId: params.attachId,
					processing: params.processing || false,
					resId: params.resId
				});

				attach.run();
			}
		},

		unlockAttachment: function (p, attach) {
			var attachUnlocker = this.rwom1('#attachUnlocker');

			attachUnlocker.pay({
				messageAttachmentId: attach.attachId,
				price: attach.price,
				title: attach.attachTitle
			});
		},

		inboxSocketCallback: function (response) {
			var dl = fox.createDl();
			var respClone = fox.clone(response, true);

			dl.setCollection(respClone.answer.attachments.collection);
			respClone.answer.attachments = dl.getObjectValue('attachments');

			this.addMessage(respClone.answer, true);
		},

		deactivate: function () {
			_.resetScrollState.call(this);
			this._removeWindowFocusEvent();

			this.callParent('deactivate', arguments);
		},

		_onWindowFocus: function (e) {
			e.data.widget.delayedAsReadMarking(e.data.delay);
		},

		_addWindowFocusEvent: function (argument) {
			$(window).on('focus', {widget: this, delay: _.MARKREADDELAY}, this._onWindowFocus);
		},

		_removeWindowFocusEvent: function (argument) {
			$(window).off('focus', this._onWindowFocus);
		},

		delayedAsReadMarking: function (delay) {
			if (this._active === false) {
				return false;
			}

			this.readTimer = setTimeout(function () {
				if (fox.dom.documentHasFocus()) {
					fox.site.dispatchEvent('readNewMessage', fox.getEnv('site.conversationId'));
				}
			}, delay);
		},

		showMessageReadStatus: function (params) {
			var
				list = this.rwom1('#list'),
				mes, $mes;

			params = params.answer;

			if (this._active) {
				mes = list.filter('id', Number(params.id));

				if (mes.length) {
					if (list._indom) {
						mes[0].value.transferState = 2;

						$mes = $(list.dom1('#message-' + params.id + ' .message-read-status'));

						$mes.text('Seen');
					}
				}
			} else {
				this.seenMessage = params.id;
			}
		},

		_handleGlobalUnlockEvent: function (data, w, e) {
			fox.each(this.wom('~.Conversation_AttachItem'), function (w) {
				w.unlockSuccessfully(data);
			}, this);

			this._sendPaySuccessMessage(data);
		},

		addMessage: function (message, fromModel) {
			var list = this.rwom1('#list');

			function render (message) {
				this._addInProgress = true;

				var c = _.prepareCollection.call(
					this,
					list.dataModel.slice(-3).map(function (v) {return v.value;}).concat([message]),
					fromModel,
					true
				);

				if (list.getLength()) {
					if (!list._active) {
						list.updateItem(c[c.length - 2], list.getLength(), !list._active);
						list.appendItem(c[c.length - 1], !list._active);
					} else {
						this.waitEvent(list, 'addedToDom', function () {
							list.appendItem(c[c.length - 1]);
						}, {prefix: 'ifExist'});

						list.updateItem(c[c.length - 2], list.getLength());
					}

				} else {
					list.appendItem(c[c.length - 1], !list._active);

					return list.idStart - 1;
				}

				return list.idStart;
			}

			this.handleEvent(list, 'addedToDom', function () {
				this._addInProgress = false;

				if (!this._waitForQueue) return false;

				if (this._queue.length) {
					render.call(this, this._queue.pop());
				} else {
					this._waitForQueue = false;
				}
			}.bind(this), {
				alwaysActive: true,
				prefix: 'waitQueue'
			});

			if (this._addInProgress) {
				this._waitForQueue = true;
				return this._queue.push(message);
			}

			return render.call(this, message);
		}

	}, 'Grid');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/conversation/conversationViewer.js
// module id = 862
// module chunks = 4